import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const WhatsAppMessageRoutes = defineRoute({
    record: {
        route: {
            path: "/whatsapp-message",
            component: () => loadView(import("./WhatsAppMessageTable.vue")),
        },
    },
});
